import { render, staticRenderFns } from "./WarningModal.vue?vue&type=template&id=3fb0a932&scoped=true"
import script from "./WarningModal.vue?vue&type=script&lang=js"
export * from "./WarningModal.vue?vue&type=script&lang=js"
import style0 from "./WarningModal.vue?vue&type=style&index=0&id=3fb0a932&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb0a932",
  null
  
)

export default component.exports